export default __webpack_public_path__ + "static/media/img-0208-mexico-full-face.70a0aa50.png";